import { NotificationOptions } from './types';
import NNotification from '../NNotification.vue';
import { createComponent } from './element';

const Notification = (options: NotificationOptions) => {
  createComponent(NNotification, options);
};

export default Notification;
